import { render, staticRenderFns } from "./accumulativeTotal.vue?vue&type=template&id=24f20dee"
import script from "./accumulativeTotal.vue?vue&type=script&lang=js"
export * from "./accumulativeTotal.vue?vue&type=script&lang=js"
import style0 from "./accumulativeTotal.vue?vue&type=style&index=0&id=24f20dee&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports